import isMainType from "@/pages/Edit/common/page/isMainPageType";

export default (page) => {
  return  isMainType(page.type )
}
